import React, { ReactElement, useMemo } from "react";
import "./css/style.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { IState } from "./types";
import { CssBaseline } from "@mui/material";
import MainContainer from "./MainContainer";
import { SystemContextProvider } from "./context/systemContext";
import { DelayContextProvider } from "./context/delayContext";

const App = (): ReactElement => {
  const darkMode = useSelector((state: IState) => state.darkMode);

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: darkMode ? "dark" : "light",
          primary: {
            light: "#90caf9",
            main: "#2196f3",
            dark: "#1976d2",
            contrastText: "#fff",
          },
          secondary: {
            light: "#ce93d8",
            main: "#9c27b0",
            dark: "#7b1fa2",
            contrastText: "#fff",
          },
          error: {
            light: "#ef9a9a",
            main: "#f44336",
            dark: "#d32f2f",
            contrastText: "#fff",
          },
          warning: {
            light: "#ffcc80",
            main: "#ff9800",
            dark: "#f57c00",
            contrastText: "#fff",
          },
          info: {
            light: "#81d4fa",
            main: "#03a9f4",
            dark: "#0288d1",
            contrastText: "#fff",
          },
          success: {
            light: "#a5d6a7",
            main: "#4caf50",
            dark: "#388e3c",
            contrastText: "#fff",
          },
          background: darkMode
            ? { paper: "#424242", default: "#303030" }
            : { paper: "#fff", default: "#f3f7f9" },
          tonalOffset: 0.2,
        },
        components: {
          MuiFormControl: {
            styleOverrides: {
              root: {
                marginTop: "8px"
              }
            }
          },
          MuiCardContent: {
            styleOverrides: {
              root: {
                padding: 8,
                "&:last-child": {
                  paddingBottom: 8,
                }
              }
            }
          },
          MuiDialogTitle: {
            styleOverrides: {
              root: {
                backgroundColor: "#0d47a1",
                color: "#f3f7f9"
              }
            }
          },
        }
      }),
    [darkMode]);

  theme.palette.mode = darkMode ? "dark" : "light";

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline/>
      {/*<GlobalStyles/>*/}
      <SystemContextProvider>
        <DelayContextProvider>
          <MainContainer/>
        </DelayContextProvider>
      </SystemContextProvider>
    </ThemeProvider>
  );
};

export default App;
